import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { SuiButton } from '@splashthat/sui';
import { getFormSessionStepsBackButtonLabel } from 'common/entities/form/sessionRegistration';
import { DEFAULT_BUTTON_POSITION } from 'common/entities/form/styleConfiguration/defaultValues';
import { FULL } from 'common/entities/form/styleConfiguration/constants';
import { getButtonPosition } from 'common/entities/form/styleConfiguration/selectors';
import SanitizedHTML from '../SanitizedHTML';
import { setSessionsStep } from '../../actions';
import { FORM_SESSIONS_STEPS } from '../../constants/sessions';

const StyledBackButton = styled(SuiButton)`
    flex: ${(props) => props.buttonPosition === FULL && '1'};
`;

const FormBackButton = ({ formId, isPreview }) => {
    const dispatch = useDispatch();
    const buttonPosition = useSelector((state) => getButtonPosition(state, formId)) || DEFAULT_BUTTON_POSITION;
    const label = useSelector((state) => getFormSessionStepsBackButtonLabel(state, formId));

    const handleBackButtonClick = () => {
        if (!isPreview) {
            dispatch(setSessionsStep(FORM_SESSIONS_STEPS.GUEST_INFORMATION));
        }
    };

    return (
        <StyledBackButton
            type="button"
            variation="secondary"
            label={<SanitizedHTML innerHtml={label} />}
            onClick={handleBackButtonClick}
            buttonPosition={buttonPosition}
            data-qa="FormBackButton"
        />
    );
};

FormBackButton.propTypes = {
    formId: PropTypes.string.isRequired,
    isPreview: PropTypes.bool.isRequired,
};

export default FormBackButton;
